import { styled } from 'styles';

export const typographyModification = {
  headline1: {
    fontFamily: 'Montserrat !important',
    fontWeight: 600,
    fontSize: '56px !important',
    lineHeight: '120% !important',
  },
  headline2: {
    fontFamily: 'Montserrat !important',
    fontWeight: 600,
    fontSize: '48px !important',
    lineHeight: '120% !important',
  },
  headline3: {
    fontFamily: 'Montserrat !important',
    fontWeight: 600,
    fontSize: '32px !important',
    lineHeight: '120%',
  },
  headline4: {
    fontFamily: 'Montserrat !important',
    fontWeight: 600,
    fontSize: '24px !important',
    lineHeight: '120% !important',
  },
  headline5: {
    fontFamily: 'Montserrat !important',
    fontWeight: 600,
    fontSize: '18px !important',
    lineHeight: '120% !important',
  },
  headline6: {
    fontFamily: 'Montserrat !important',
    fontWeight: 600,
    fontSize: '16px !important',
    lineHeight: '120% !important',
  },
  headline7: {
    fontFamily: 'Montserrat !important',
    fontWeight: 600,
    fontSize: '14px !important',
    lineHeight: '120% !important',
  },

  body1: {
    fontFamily: 'Source Sans Pro !important',
    fontWeight: 400,
    fontSize: '20px !important',
    lineHeight: '140% !important',
  },
  body2: {
    fontFamily: 'Source Sans Pro !important',
    fontWeight: 400,
    fontSize: '18px !important',
    lineHeight: '140% !important',
  },
  body3: {
    fontFamily: 'Source Sans Pro !important',
    fontWeight: 400,
    fontSize: '16px !important',
    lineHeight: '140% !important',
  },
  body4: {
    fontFamily: 'Source Sans Pro !important',
    fontWeight: 400,
    fontSize: '14px !important',
    lineHeight: '140% !important',
  },
  body5: {
    fontFamily: 'Source Sans Pro !important',
    fontWeight: 400,
    fontSize: '12px !important',
    lineHeight: '120% !important',
  },
  body6: {
    fontFamily: 'Source Sans Pro !important',
    fontWeight: 400,
    fontSize: '10px !important',
    lineHeight: '120% !important',
  },
};

export const ContainerContent = styled('div', {
  my: 36,
  '& h1 span, h1': typographyModification.headline3,
  '& h2 span, h2': typographyModification.headline4,
  '& h3 span, h3': typographyModification.headline5,
  '& h4 span, h4': typographyModification.headline6,
  '& li span, li, p span, p': typographyModification.body3,
  '& ol, ul,h1, h2, h3, h4': {
    my: '1em',
  },
  '& ol, ul': {
    pl: 40,
  },
  '@md': {
    '& h1 span, h1': typographyModification.headline2,
    '& h2 span, h2': typographyModification.headline3,
    '& h3 span, h3': typographyModification.headline4,
    '& h4 span, h4': typographyModification.headline5,
    '& li span, li, p span, p': typographyModification.body1,
    '& p': { minHeight: 19 },
  },
});
